(function() {
  let pixelsLoaded = false;
  
  function safeLoadPixels() {
    if (pixelsLoaded) return;
    pixelsLoaded = true;
    document.dispatchEvent(new CustomEvent('page:ready'));
    setTimeout(() => document.dispatchEvent(new CustomEvent('pixels:ready')), 100);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeLoadPixels);
  } else {
    safeLoadPixels();
  }
  
  window.addEventListener('error', function(e) {
    if (e.message && (e.message.includes('web-pixel') || e.message.includes('cross-origin'))) {
      console.warn('Pixel error blocked:', e.message);
      e.preventDefault();
      return false;
    }
  });
})();